import { GridLocaleText } from "@mui/x-data-grid";

export const thTHGrid: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: "ไม่มีข้อมูล",
  noResultsOverlayLabel: "ไม่พบผลลัพธ์",
  // Density selector toolbar
  toolbarDensity: "ความหนาแน่น",
  toolbarDensityLabel: "ความหนาแน่น",
  toolbarDensityCompact: "กะทัดรัด",
  toolbarDensityStandard: "มาตรฐาน",
  toolbarDensityComfortable: "สบายตา",
  // Columns selector toolbar
  toolbarColumns: "คอลัมน์",
  toolbarColumnsLabel: "เลือกคอลัมน์",
  // Filters toolbar
  toolbarFilters: "ตัวกรอง",
  toolbarFiltersLabel: "แสดงตัวกรอง",
  toolbarFiltersTooltipHide: "ซ่อนตัวกรอง",
  toolbarFiltersTooltipShow: "แสดงตัวกรอง",
  toolbarFiltersTooltipActive: (count) => `ตัวกรองที่ใช้งาน ${count} รายการ`,
  // Quick filter toolbar
  toolbarQuickFilterPlaceholder: "ค้นหา…",
  toolbarQuickFilterLabel: "ค้นหา",
  toolbarQuickFilterDeleteIconLabel: "ล้าง",
  // Export toolbar
  toolbarExport: "ส่งออก",
  toolbarExportLabel: "ส่งออก",
  toolbarExportCSV: "ดาวน์โหลดเป็น CSV",
  toolbarExportPrint: "พิมพ์",
  toolbarExportExcel: "ดาวน์โหลดเป็น Excel",
  // Columns management
  columnsManagementSearchTitle: "ค้นหา",
  columnsManagementNoColumns: "ไม่มีคอลัมน์",
  columnsManagementShowHideAllText: "แสดง/ซ่อนทั้งหมด",
  columnsManagementReset: "รีเซ็ต",
  columnsManagementDeleteIconLabel: "ล้าง",
  // Filter panel
  filterPanelAddFilter: "เพิ่มตัวกรอง",
  filterPanelRemoveAll: "ลบทั้งหมด",
  filterPanelDeleteIconLabel: "ลบ",
  filterPanelLogicOperator: "ตัวดำเนินการตรรกะ",
  filterPanelOperator: "ตัวดำเนินการ",
  filterPanelOperatorAnd: "และ",
  filterPanelOperatorOr: "หรือ",
  filterPanelColumns: "คอลัมน์",
  filterPanelInputLabel: "ค่า",
  filterPanelInputPlaceholder: "ค่าตัวกรอง",
  // Filter operators
  filterOperatorContains: "ประกอบด้วย",
  filterOperatorDoesNotContain: "ไม่ประกอบด้วย",
  filterOperatorEquals: "เท่ากับ",
  filterOperatorDoesNotEqual: "ไม่เท่ากับ",
  filterOperatorStartsWith: "เริ่มต้นด้วย",
  filterOperatorEndsWith: "ลงท้ายด้วย",
  filterOperatorIs: "คือ",
  filterOperatorNot: "ไม่ใช่",
  filterOperatorAfter: "หลังจาก",
  filterOperatorOnOrAfter: "ตั้งแต่หรือหลังจาก",
  filterOperatorBefore: "ก่อน",
  filterOperatorOnOrBefore: "ตั้งแต่หรือก่อน",
  filterOperatorIsEmpty: "ว่างเปล่า",
  filterOperatorIsNotEmpty: "ไม่ว่างเปล่า",
  filterOperatorIsAnyOf: "เป็นหนึ่งใน",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators
  headerFilterOperatorContains: "ประกอบด้วย",
  headerFilterOperatorDoesNotContain: "ไม่ประกอบด้วย",
  headerFilterOperatorEquals: "เท่ากับ",
  headerFilterOperatorDoesNotEqual: "ไม่เท่ากับ",
  headerFilterOperatorStartsWith: "เริ่มต้นด้วย",
  headerFilterOperatorEndsWith: "ลงท้ายด้วย",
  headerFilterOperatorIs: "คือ",
  headerFilterOperatorNot: "ไม่ใช่",
  headerFilterOperatorAfter: "หลังจาก",
  headerFilterOperatorOnOrAfter: "ตั้งแต่หรือหลังจาก",
  headerFilterOperatorBefore: "ก่อน",
  headerFilterOperatorOnOrBefore: "ตั้งแต่หรือก่อน",
  headerFilterOperatorIsEmpty: "ว่างเปล่า",
  headerFilterOperatorIsNotEmpty: "ไม่ว่างเปล่า",
  headerFilterOperatorIsAnyOf: "เป็นหนึ่งใน",
  "headerFilterOperator=": "เท่ากับ",
  "headerFilterOperator!=": "ไม่เท่ากับ",
  "headerFilterOperator>": "มากกว่า",
  "headerFilterOperator>=": "มากกว่าหรือเท่ากับ",
  "headerFilterOperator<": "น้อยกว่า",
  "headerFilterOperator<=": "น้อยกว่าหรือเท่ากับ",
  // Filter values
  filterValueAny: "ใดๆ",
  filterValueTrue: "จริง",
  filterValueFalse: "เท็จ",
  // Column menu
  columnMenuLabel: "เมนู",
  columnMenuAriaLabel: (columnName) => `เมนูคอลัมน์ ${columnName}`,
  columnMenuShowColumns: "แสดงคอลัมน์",
  columnMenuManageColumns: "จัดการคอลัมน์",
  columnMenuFilter: "กรอง",
  columnMenuHideColumn: "ซ่อนคอลัมน์",
  columnMenuUnsort: "ยกเลิกการเรียงลำดับ",
  columnMenuSortAsc: "เรียงจากน้อยไปมาก",
  columnMenuSortDesc: "เรียงจากมากไปน้อย",
  // Column header
  columnHeaderFiltersTooltipActive: (count) =>
    `ตัวกรองที่ใช้งาน ${count} รายการ`,
  columnHeaderFiltersLabel: "แสดงตัวกรอง",
  columnHeaderSortIconLabel: "เรียงลำดับ",
  // Footer
  footerRowSelected: (count) => `เลือกแล้ว ${count.toLocaleString()} แถว`,
  footerTotalRows: "จำนวนแถวทั้งหมด:",
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} จาก ${totalCount.toLocaleString()}`,
  // Checkbox selection
  checkboxSelectionHeaderName: "เลือก",
  checkboxSelectionSelectAllRows: "เลือกทุกแถว",
  checkboxSelectionUnselectAllRows: "ยกเลิกเลือกทุกแถว",
  checkboxSelectionSelectRow: "เลือกแถว",
  checkboxSelectionUnselectRow: "ยกเลิกเลือกแถว",
  // Boolean cell
  booleanCellTrueLabel: "ใช่",
  booleanCellFalseLabel: "ไม่ใช่",
  // Actions cell
  actionsCellMore: "เพิ่มเติม",
  // Column pinning
  pinToLeft: "ปักหมุดทางซ้าย",
  pinToRight: "ปักหมุดทางขวา",
  unpin: "เลิกปักหมุด",
  // Tree Data
  treeDataGroupingHeaderName: "กลุ่ม",
  treeDataExpand: "ดูรายการย่อย",
  treeDataCollapse: "ซ่อนรายการย่อย",
  // Grouping columns
  groupingColumnHeaderName: "กลุ่ม",
  groupColumn: (name) => `จัดกลุ่มตาม ${name}`,
  unGroupColumn: (name) => `ยกเลิกจัดกลุ่มตาม ${name}`,
  // Master/detail
  detailPanelToggle: "สลับแผงรายละเอียด",
  expandDetailPanel: "ขยาย",
  collapseDetailPanel: "ย่อ",
  // Row reordering
  rowReorderingHeaderName: "จัดเรียงแถวใหม่",
  // Aggregation
  aggregationMenuItemHeader: "การรวมค่า",
  aggregationFunctionLabelSum: "ผลรวม",
  aggregationFunctionLabelAvg: "ค่าเฉลี่ย",
  aggregationFunctionLabelMin: "ค่าต่ำสุด",
  aggregationFunctionLabelMax: "ค่าสูงสุด",
  aggregationFunctionLabelSize: "จำนวน",
};
